"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Testing = void 0;
class Testing {
    sayHelloTo(name) {
        return `YO! ${name}`;
    }
}
exports.Testing = Testing;
